module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMOpy+XO4fCFtdpHj8f////a6fRUl8tgns7z+Pt4rdZsptKRvN220unn8PidxOEu33L8AAAAB3RSTlMAYL8AIM/vi50ITwAAANNJREFUeF7t2MkOwjAMRdGkU+ah4/9/Kk0LBUGElNhigXz3OWvnsRRvBKCGt3usbbteAOu7BHWDADd0O9QLhPqWcYESZw0O1DCB1D9DBI1SSQ2HjLIpZ6CQtGcLFIr2nodBk300/QoiiCCCCCKIIIIImp6PZgAU1nRX+RNyFxRKIRPtkRqN8Iu9EqXQbLOpYmjLQzMWZIohnXW2ijt7zTjOVEAhfjgxVF3+wb05ztf+RfQrtWrIp8ZrqY62QB+/bxGENrKgzT5YQxTaNIY51u1hzIc3U5SaUdPCyaUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f1ef.png
// module id = 602
// module chunks = 0